import PromptContent, { CountupDefinition } from "slotworks/components/prompt/prompt-content";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import soundManager from "slotworks/sound/sound-manager";
import { SoundEvent } from "slotworks/sound/sound-events";
import currency from "slotworks/i18n/currency";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { LimitBitmapText } from "utils/utils";

export default class G288PromptContent extends PromptContent {

    protected startCountup(countup: CountupDefinition, contentName: string) {
        return new Contract<void>((resolve) => {
            if (countup.value > 0) {
                soundManager.event(SoundEvent.prompt_countup_start);
                soundManager.event(SoundEvent.prompt_countup_start_SCENE, this.scene.name);
            }

            const onComplete = () => {
                if (countup.value > 0) {
                    soundManager.event(SoundEvent.prompt_countup_end);
                    soundManager.event(SoundEvent.prompt_countup_end_SCENE, this.scene.name);
                }

                this.setTextValue(contentName, currency.format(countup.value, undefined, undefined, true));
                resolve(null);
                document.body.removeEventListener(ButtonEvent.POINTER_DOWN.getEventString(), skipCountup, true);
            };

            const tickObj = { value: 0 };
            const tween = new TweenJS.Tween(tickObj)
                .to({ value: countup.value }, countup.time)
                .onUpdate(() => {
                    this.setTextValue(contentName, currency.format(tickObj.value, undefined, undefined, true, true));
                })
                .onComplete(onComplete);

            const skipCountup = () => {
                tween.stop();
                onComplete();
            };

            document.body.addEventListener(ButtonEvent.POINTER_DOWN.getEventString(), skipCountup, true);

            tween.start();
        });
    }

    private setTextValue(id: string, text: string) {
        const textField = Layers.Prompts.getBitmapText(id);

        if (textField) {
            textField.text = text;
            LimitBitmapText(textField, Layers.Prompts.getPosition("limits"));            
        }
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/prompt/prompt-content.ts